import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IUserSelectorBuilder from "../../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import IButtonBuilder from "../../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";

type Inputs = "coordinador" | "sesiones";
type Buttons = "aceptar" | "cancelar";

export const programaCedulaReglamentoFormConfig: FormBuilderConfig<
  Inputs,
  Buttons
> = {
  inputs: [
    {
      name: "coordinador",
      label: "Coordinador de club",
      bts: {
        xCol: 12
      },
      component: IUserSelectorBuilder
    },
    {
      name: "sesiones",
      label: "No de Sesiones",
      bts: {
        xCol: 12
      },
      component: ITextBuilder,
      props: {
        maxlength: 100
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Aceptar",
      isSubmit: true,
      bts: {
        mCol: 3,
        mOff: 6
      },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    coordinador: {
      required: true
    },
    sesiones: {
      required: true
    }
  },
  rows: [["coordinador", "sesiones", "aceptar", "cancelar"]]
};
